export var DocsBlockTokenNameFormat;
(function (DocsBlockTokenNameFormat) {
    /** Token name */
    DocsBlockTokenNameFormat["name"] = "Name";
    /** Group and token name */
    DocsBlockTokenNameFormat["groupAndName"] = "GroupAndName";
    /** Full path */
    DocsBlockTokenNameFormat["fullPath"] = "FullPath";
    /** Custom property */
    DocsBlockTokenNameFormat["customProperty"] = "CustomProperty";
})(DocsBlockTokenNameFormat || (DocsBlockTokenNameFormat = {}));
